import authToken from './authToken'
import { decodeJwtPayload } from './decodeJwt'

interface TokenPayload {
  scope?: string
  realm_access?: { roles?: string[] }
}

// Role → sa.* scope mapping (mirrors backend permissions.py). `admin` is omitted on purpose:
// it's the dashboard-entry gate only — concrete sa.* scopes must be granted directly.
const ROLE_SCOPES = new Map<string, string[]>([
  [
    'beheerder',
    [
      'sa.organization:read',
      'sa.mcp:read',
      'sa.proxy:read',
      'sa.org_link:read',
      'sa.org_link:write',
      'sa.access_request:read',
      'sa.access_request:write',
      'sa.platform_request:read',
      'sa.platform_request:write',
      'sa.monitoring:read',
      'sa.dashboard:read',
    ],
  ],
  [
    'gebruiker',
    [
      'sa.mcp:read',
      'sa.org_link:read',
      'sa.access_request:read',
      'sa.access_request:write',
    ],
  ],
])

export const getScope = (): string[] => {
  try {
    const token = authToken.getToken() || ''
    const payload = decodeJwtPayload<TokenPayload>(token)
    if (!payload) return []

    const scopes: string[] = (payload.scope || '').split(' ').filter(Boolean)
    const realmRoles: string[] = payload.realm_access?.roles ?? []
    const resolved: string[] = [...scopes]

    scopes.concat(realmRoles).forEach((grant) => {
      if (grant.startsWith('sa.') && !resolved.includes(grant)) {
        resolved.push(grant)
        return
      }
      const mapped = ROLE_SCOPES.get(grant)
      if (!mapped) return
      mapped.forEach((s) => {
        if (!resolved.includes(s)) resolved.push(s)
      })
    })

    return resolved
  } catch {
    return []
  }
}
